export async function showConfetti(element: HTMLElement) {
	const party = await import("party-js")
	party.confetti(element, {
		count: party.variation.range(55, 75),
		size: party.variation.range(0.8, 1.2),
		spread: party.variation.range(45, 60),
		speed: party.variation.range(350, 650),
	})
}
